/**
 * Created by iosc on 2018/1/15.
 */

import React, {PureComponent} from 'react'
import Contact from './Contact'
import './Home.css'

class Home extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {size: window.innerWidth};
		window.onresize = (e) => {
			this.setState({size: window.innerWidth})
		}
	}

	render() {
		return (
			<div>
				<a href="/ad">
					<div style={{position: 'relative'}} className='three-bounce'>
						<img alt="banner1" src={require('./images/homeb1.jpg')}
								 style={{display: 'block', width: '100%'}}/>
						<img className="one" alt="banner1" src={require('./images/homeb2.jpg')}
								 style={{display: 'block', width: '100%', position: 'absolute', top: '0px'}}/>
						<img className="two" alt="banner1" src={require('./images/homeb3.jpg')}
								 style={{display: 'block', width: '100%', position: 'absolute', top: '0px'}}/>
					</div>
				</a>
				<div style={{display: 'flex', height: window.innerWidth / 1920 * 360 + 'px'}}>
					<a href="/ad#global" style={{display: 'block', width: 707.0 / 19.20 + '%'}}>
						<img alt="home1" src={require('./images/home10.png')} style={{display: 'block', width: '100%'}}/>
					</a>
					<a href="/ad#normal" style={{display: 'block', width: 505.0 / 19.20 + '%'}}>
						<img alt="home1" src={require('./images/home11.png')} style={{display: 'block', width: '100%'}}/>
					</a>
					<a href="/ad#train" style={{display: 'block', width: 708.0 / 19.20 + '%'}}>
						<img alt="home1" src={require('./images/home12.png')} style={{display: 'block', width: '100%'}}/>
					</a>
				</div>
				<img alt="home2" src={require('./images/home2.jpg')} style={{display: 'block', width: '100%'}}/>
				<img alt="home3" src={require('./images/home3.jpg')} style={{display: 'block', width: '100%'}}/>
				<img alt="home4" src={require('./images/home4.jpg')} style={{display: 'block', width: '100%'}}/>
				<img alt="home5" src={require('./images/home5.jpg')} style={{display: 'block', width: '100%'}}/>
				<Contact/>
			</div>
		)
	}
}

export default Home


// WEBPACK FOOTER //
// ./src/Home.js